import { array, object } from 'yup';

const useAopImportSchema = () => ({
  aopImport: array()
    .nullable(true)
    .of(object()),
});

export default useAopImportSchema;
